'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var Strings_Toolbar = /** @class */ (function () {
    function Strings_Toolbar() {
    }
    Strings_Toolbar.leftPaneToggleButtonTooltip = "Toggle Left Panel";
    Strings_Toolbar.rightPaneToggleButtonTooltip = "Toggle Right Panel";
    Strings_Toolbar.firstPageButtonTooltip = "First Page";
    Strings_Toolbar.previousPageButtonTooltip = "Previous Page";
    Strings_Toolbar.nextPageButtonTooltip = "Next Page";
    Strings_Toolbar.lastPageButtonTooltip = "Last Page";
    Strings_Toolbar.zoomOutButtonTooltip = "Zoom Out";
    Strings_Toolbar.zoomInButtonTooltip = "Zoom In";
    Strings_Toolbar.fullscreeButtonTooltip = "Full Screen";
    Strings_Toolbar.exitFullscreeButtonTooltip = "Exit Full Screen";
    Strings_Toolbar.readModeTooltip = "Read Mode";
    Strings_Toolbar.exitReadModeTooltip = "Exit Read Mode";
    Strings_Toolbar.downloadIconTooltip = "Download";
    return Strings_Toolbar;
}());

var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePageChange = function (event) {
            if (event.key === 'Enter') {
                if (_this.validatePageNumber(Number(event.target.value))) {
                    _this.props.onGotoPage && _this.props.onGotoPage(Number(event.target.value));
                }
                else {
                    _this.props.onGotoPage && _this.props.onGotoPage(_this.props.totalPages != undefined ? _this.props.totalPages : 0);
                }
            }
        };
        _this.handleFirstPage = function () {
            _this.validatePageNumber(1) && _this.props.onFirstPage && _this.props.onFirstPage();
        };
        _this.handlePreviousPage = function () {
            _this.validatePageNumber((_this.props.currentPage != undefined ? _this.props.currentPage : 0) - 1) && _this.props.onPreviousPage && _this.props.onPreviousPage();
        };
        _this.handleNextPage = function () {
            _this.validatePageNumber((_this.props.currentPage != undefined ? _this.props.currentPage : 0) + 1) && _this.props.onNextPage && _this.props.onNextPage();
        };
        _this.handleLastPage = function () {
            _this.validatePageNumber((_this.props.totalPages != undefined ? _this.props.totalPages : 0)) && _this.props.onLastPage && _this.props.onLastPage();
        };
        _this.state = {
            currentPage: 0
        };
        return _this;
    }
    Pagination.prototype.componentDidMount = function () {
        this.setState({ currentPage: this.props.currentPage != undefined ? this.props.currentPage : 0 });
    };
    Pagination.prototype.componentWillUpdate = function (nextProps, nextState) {
        var currentPage = 0;
        if (this.state.currentPage !== nextState.currentPage) {
            currentPage = nextState.currentPage;
        }
        else {
            currentPage = nextProps.currentPage != undefined ? nextProps.currentPage : 0;
        }
        this.state.currentPage !== currentPage && this.setState({ currentPage: currentPage });
    };
    Pagination.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.state.currentPage !== nextState.currentPage
            || this.props.currentPage !== nextProps.currentPage
            || this.props.totalPages !== nextProps.totalPages) {
            return true;
        }
        return false;
    };
    Pagination.prototype.validatePageNumber = function (page) {
        if (page > 0 && page <= (this.props.totalPages != undefined ? this.props.totalPages : 0)) {
            return true;
        }
        return false;
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var disablePagination = this.props.disablePagination;
        return (React.createElement("div", { className: "icon-bar", style: { pointerEvents: disablePagination ? 'none' : 'auto' } },
            React.createElement("a", { className: this.props.currentPage == 1 || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.firstPageButtonTooltip, onClick: this.handleFirstPage },
                React.createElement("i", { className: "fa fa-angle-double-left" })),
            React.createElement("a", { className: this.props.currentPage == 1 || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.previousPageButtonTooltip, onClick: this.handlePreviousPage },
                React.createElement("i", { className: "fa fa-angle-left" })),
            React.createElement("a", { className: this.props.currentPage == this.props.totalPages || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.nextPageButtonTooltip, onClick: this.handleNextPage },
                React.createElement("i", { className: "fa fa-angle-right" })),
            React.createElement("a", { className: this.props.currentPage == this.props.totalPages || disablePagination ? "icon-disabled d-none d-sm-block" : "icon d-none d-sm-block", title: Strings_Toolbar.lastPageButtonTooltip, onClick: this.handleLastPage },
                React.createElement("i", { className: "fa fa-angle-double-right" })),
            React.createElement("input", { id: "pageNumber", type: "text", className: "form-control toolbar-item-form-control toolbar-item-text-box", onKeyDown: this.handlePageChange, value: this.state.currentPage, onChange: function (event) { !isNaN(event.target.value) && _this.setState({ currentPage: event.target.value }); }, disabled: this.props.totalPages == 0 || disablePagination }),
            React.createElement("label", { htmlFor: "pageNumber", className: "toolbar-item-label" },
                " of ",
                this.props.totalPages,
                " "),
            React.createElement("a", { className: "divider d-none d-md-block" })));
    };
    Pagination.displayName = "Pagination";
    return Pagination;
}(React.Component));

exports.default = Pagination;
exports.Pagination = Pagination;
